import {ActionReducerMapBuilder, AsyncThunk, Draft, PayloadAction, SerializedError} from '@reduxjs/toolkit';
import {ApiError} from '../common/components/ErrorBoundary/ErrorBoundary';

export type ThunkState = {
    pending: number | 'idle';
    errors: string[];
};

type Reducer<TState, TEntity, TPayload> = (state: Draft<TState>, action: PayloadAction<TEntity, string, {
    arg: TPayload;
    requestId: string;
    requestStatus: 'fulfilled' | 'pending' | 'rejected'
}, never>) => void;

type Handler<TState, TEntity, TPayload> = {
    builder: ActionReducerMapBuilder<TState>;
    thunk: AsyncThunk<TEntity, TPayload, {}>;
    onSuccess?: Reducer<TState, TEntity, TPayload>,
    onPending?: Reducer<TState, undefined, TPayload>,
    onError?: Reducer<TState, unknown, TPayload>,
};
type SerializedErrorType = SerializedError & {data?: ApiError,statusCode? : number, traceId?: string};
const commonProperties: Array<keyof SerializedErrorType>  = [
    'name',
    'message',
    'stack',
    'code',
    'data',
    'statusCode'
];

export const miniSerializeError = (value: any): SerializedError => {
    if (typeof value === 'object' && value !== null) {
        const simpleError: SerializedError & {data?: ApiError,statusCode? : number, traceId?: string} = {};
        for (const property of commonProperties) {
            if (value[property]) {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
export function addHandlers<TState extends ThunkState, TEntity, TPayload>({ builder, thunk, onSuccess, onPending, onError }: Handler<TState, TEntity, TPayload>) {
    return builder
        .addCase(thunk.pending, (state, action) => {
            if (typeof state.pending === 'string') {
                state.pending = 1;
            } else {
                state.pending += 1;
            }
            onPending?.(state, action);
        })
        .addCase(thunk.fulfilled, (state, action) => {
            state.errors = [];
            if (typeof state.pending === 'string') {
                state.pending = 0;
            } else {
                state.pending -= 1;
            }
            onSuccess?.(state, action);
        })
        .addCase(thunk.rejected, (state, action) => {
            if (typeof state.pending === 'string') {
                state.pending = 0;
            } else {
                state.pending -= 1;
            }
            state.errors.push(action.error.message ?? 'Noe gikk galt');
            onError?.(state, action);
        });
}
